export enum StorageType { Local = 1, Session }